import React from 'react'

//starting with capital letter will ensure this is treated as a component
const VoucherGridItemD = ({formObject, viewData, rowKey}) => {

    return (
        <div className="saras-cell">
            <ul className="uiSearchSubList">
                {Object.values(viewData.childRows).map((row,index)=>(
                    <li>
                        <span className="sItemID uiCenter">{row.rowValues.docId.valF}</span>
                        <span className="sItemCode">{row.rowValues.docDate.valF}</span>
                        <span className="sItemWeight">{row.rowValues.daysOverdue.valF}</span>
                    </li>
                ))
                }
            </ul>
        </div>
    );
}

export default VoucherGridItemD
